export const formatFecha = (fecha) => {
    const fechaObj = new Date(fecha);
    const day = fechaObj.getDate().toString().padStart(2, "0");
    const month = (fechaObj.getMonth() + 1).toString().padStart(2, "0");
    const year = fechaObj.getFullYear();
    return `${day}/${month}/${year}`;
  };